/* -------------------------------------------------------------------------- *
 * JavaScript Modules *
 * -------------------------------------------------------------------------- */

import Consent from './modules/consent';
import Notification from './modules/notification';
import StickyNav from './modules/stickyNav';
import Toggle from './modules/toggle';
import LazyLoad from './modules/lazyLoad';

/* -------------------------------------------------------------------------- *
 * Module Initialization *
 * -------------------------------------------------------------------------- */

/* ----------------- *
 * Load on All Pages *
 * ----------------- */

StickyNav.init();

/* ------------------ *
 * Load When Required *
 * ------------------ */

if (document.querySelector(Consent.selector) !== null) {
    Consent.init();
}

if (document.querySelector(Notification.selector) !== null) {
    Notification.init();
}

if (document.querySelector(Toggle.selector) !== null) {
    Toggle.init();
}

if (document.querySelector(LazyLoad.selector) !== null) {
    LazyLoad.init();
}
